import * as yup from 'yup';

const validationSchema = (formatMessage, isAdmin = false) =>
  yup
    .object({
      title: yup.string().required(
        formatMessage({
          id: 'TITLE_IS_REQUIRED',
          defaultMessage: 'Title is required',
        }),
      ),
      description: yup.string().nullable(),
      typeCode: yup.string().required(
        formatMessage({
          id: 'TYPE_IS_REQUIRED',
          defaultMessage: 'Type is required',
        }),
      ),
      priorityCode: yup.string().required(
        formatMessage({
          id: 'PRIORITY_IS_REQUIRED',
          defaultMessage: 'Priority is required',
        }),
      ),
      componentCode: yup.string().nullable(),
      companyId: isAdmin
        ? yup.string().required(
            formatMessage({
              id: 'COMPANY_IS_REQUIRED',
              defaultMessage: 'Company is required',
            }),
          )
        : yup.string().nullable(),
      serviceAdministratorId: isAdmin
        ? yup.string().required(
            formatMessage({
              id: 'SERVICE_ADMINISTRATOR_IS_REQUIRED',
              defaultMessage: 'Service administrator is required',
            }),
          )
        : yup.string().nullable(),
    })
    .required();

export default validationSchema;
